<div class="sc-dropdown sc-control" #fakeInput>
  <!-- input to know if combo inside form view and fieldset is disabled-->
  <input scCombo hidden="hidden" />

  <!-- label -->
  <div>
    @if (scLabel) {
      <label class="input-label">
        {{ scLabel }}
        <span class="sc-required sc-required-star"></span>
      </label>
    }
  </div>

  <mat-select [ngModel]="value"
    [disabled]="isDisabled || fieldSetDisabled"
    [multiple]="scMultiple"
    (focus)="onComboFocus()"
    (ngModelChange)="onComboValueChange($event)">
    <mat-option>
      <ngx-mat-select-search ngModel
        (ngModelChange)="onComboOptionsSearchChange($event)"
        placeholderLabel="{{'SabisComponents.ComboboxSearchPlaceHolderLabel' | translate}}"
      noEntriesFoundLabel="{{'SabisComponents.ComboboxSearchNoEntriesFoundLabel' | translate}}"></ngx-mat-select-search>
    </mat-option>
    @if (scMultiple) {
      <mat-option value="select-all" selectAll [allValues]="internalItems" [valueField]="scValueField">Select all</mat-option>
    }
    @for (item of internalItems; track item) {
      <mat-option
        [value]="item[scValueField]">
        <span [innerHTML]="item[scDisplayField]"></span>
      </mat-option>
    }
  </mat-select>

  <!-- combo -->
  <!--<kendo-combobox #combo
  [clearButton]="scClearButton"
  [data]="internalItems"
  [textField]="scDisplayField"
  [valueField]="scValueField"
  [ngModel]="value"
  (ngModelChange)="onComboValueChange($event)"
  [disabled]="isDisabled || fieldSetDisabled"
  [placeholder]="scPlaceholder"
  [valuePrimitive]="true"
  (open)="onOpen()"
  (close)="onComboClose()"
  [ngClass]="{ 'open': isOpen }"
  (focus)="onComboFocus()"
  (keypress)="onEnterClicked($event)"
  [allowCustom]="scAllowCustom || (scInitialValue != undefined && !isItemsLoaded)"
  [virtual]="virtual">
  <ng-template kendoDropDownListNoDataTemplate>
    <span class="sc-combo-item" *ngIf="!isItemsLoaded">{{'SabisComponents.ComboboxLoading' | translate}}</span>
    <span class="sc-combo-item" *ngIf="isItemsLoaded">{{'SabisComponents.ComboboxNoData' | translate}}</span>
  </ng-template>
</kendo-combobox>-->

<div class="sc-combo-progress-outer">
  <div class="sc-combo-progress-container">
    <!--<ng-progress [direction]="'ltr+'"
    [color]="'#4286f4'"
    [trickleSpeed]="500"
    [thick]="true"
    [spinner]="false"
    [fixed]="false"
  [ease]="'easeInSine'"></ng-progress>-->
</div>
</div>
</div>
@if (!scHideValidationMessage && !isValid) {
  <p class="sc-error-message">{{ validationMessage }}</p>
}
